import React from 'react'
import { Box, IconButton } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import {
  getMetricTableBuyerCellButtonSx,
  METRIC_TABLE_BUYER_CELL_SX,
  METRIC_TABLE_BUYER_CELL_TEXT_SX
} from '../style/metricTableStyles'

const BuyerCellContent = ({ hasChildren, isOpen, value }) => (
  <Box sx={METRIC_TABLE_BUYER_CELL_SX}>
    <IconButton
      size="small"
      disabled={!hasChildren}
      sx={getMetricTableBuyerCellButtonSx(hasChildren)}
    >
      {isOpen
        ? <KeyboardArrowDownIcon fontSize="small" />
        : <KeyboardArrowRightIcon fontSize="small" />
      }
    </IconButton>

    <Box
      component="span"
      sx={METRIC_TABLE_BUYER_CELL_TEXT_SX}
    >
      {value}
    </Box>
  </Box>
)

export default BuyerCellContent
